export default __webpack_public_path__ + "static/media/cloth_10.64ffa3e3.jpg";